function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.566 9.212L5.854 5.5l3.712-3.712a.25.25 0 0 0-.354-.354L5.5 5.146 1.788 1.434a.25.25 0 0 0-.354.354L5.146 5.5 1.434 9.212a.25.25 0 0 0 .354.354L5.5 5.854l3.712 3.712a.25.25 0 0 0 .354-.354z"
});

var SvgIconCross = function SvgIconCross(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-cross",
    stroke: "#4859EE",
    strokeWidth: 1.5,
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cross.adcb6ef2.svg";
export { ForwardRef as ReactComponent };